export const validation = {
  category: "Category is required",
};
